import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { RegistrationApproverComponent } from './registration-approver.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectExculCategoryModule } from 'src/shared/modules/select-excul-category/select-excul-category.module';
import { SelectSchoolActivityModule } from 'src/shared/modules/select-school-activity/select-school-activity.module';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { SelectSchoolLocationV2Module } from 'src/shared/modules/select-school-location-v2/select-school-location-v2.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { SelectSchoolProgramCategoryModule } from 'src/shared/modules/select-school-program-category/select-school-program-category.module';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import {StatusNoDataModule} from "../../../shared/modules/status-no-data/status-no-data.module";
import {StatusLoadingModule} from "../../../shared/modules/status-loading/status-loading.module";
import {MatProgressSpinner} from "@angular/material/progress-spinner";



@NgModule({
  declarations: [RegistrationApproverComponent],
    imports: [
        CommonModule,
        FeatherModule.pick(allIcons),
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatTableModule,
        NgSelectModule,
        SelectAcademicYearOnlyModule,
        SelectSchoolLevelRelationV2Module,
        SelectSchoolLocationV2Module,
        SelectSchoolProgramCategoryModule,
        MatCardModule,
        MatSelectModule,
        SelectSchoolProgramModule,
        SelectSchoolActivityModule,
        StatusNoDataModule,
        StatusLoadingModule,
        MatProgressSpinner
    ],
  providers:[],
  exports: [RegistrationApproverComponent]
})
export class RegistrationApproverModule { }
